import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap, withLatestFrom, exhaustMap, concatMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import * as citiesActions from '../store/actions/cities.action';
import * as citiesSelectors from '../store/selectors/cities.selector';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { City } from '../models/cities.model';
import { CitiesServerService } from '../services/cities-server.service';
import { CitiesService } from '../services/cities.service';
import { EMPTY, of } from 'rxjs';

@Injectable()
export class CitiesEffects {

    constructor(
        private actions$: Actions,
        private citiesServerService: CitiesServerService,
        private citiesService: CitiesService,
        private store: Store<{ city: City }>,
        private toastr: ToastrService,
        private router: Router
    ) {}

    getCities$ = createEffect(() => this.actions$.pipe(
        ofType(citiesActions.getCities),
        exhaustMap(() =>
            this.citiesServerService.getCitiesFromServer()
            .pipe(
            map(cities => {
              
                this.citiesService.setCities(cities.cities);
                return citiesActions.getCitiesSuccess({ cities: cities.cities })
            }),
            catchError((error) => {
                console.error('Error loading cities', error);
                this.toastr.error('No se pudieron cargar las ciudades');
                return EMPTY;
            })
            ))
        )
        );

        setSelectedCity$ = createEffect(() => this.actions$.pipe(
            ofType(citiesActions.setUserSelectedCity),
            concatMap(action => {
             
              const city: City = action.city;
              return this.citiesServerService.setSelectCityToServer(city).pipe(
                map(city => {
                
                  this.citiesService.setUserSelectedCity(city);
                  return citiesActions.setUserSelectedCitySuccess({ city });
                }),
                catchError((error) => {
                  console.error('Error setting selected city', error);
                  this.toastr.error('No se pudo seleccionar la ciudad');
                  return of(citiesActions.setUserSelectedCityFailure({ error }));
                })
              );
            })
          ));

    }
